// @ts-strict-ignore
/**
 * Created by vwiny on 8/28/2017.
 */
import { Injectable, ViewContainerRef } from '@angular/core';
import { LMLoggerService } from '@services/lm-logger.service';
import { LMBusyIndicatorService } from '@services/lm-busyindicator.service';
import { LMHelperListDialogComponent } from './lm-helper-list-dialog.component';
import { LMListComponent } from '@list/lm-list.component';
import { Observable, Subject } from 'rxjs';
import { LMDialogButtonKey, LMUniqueIdService } from '@utils/index';
import { LMUrlInfoBuilderService } from '@services/lm-url-info-builder.service';
import { LMModalDialogWrapperRef, LMModalWrapperService } from '@app/services';

export enum LMHelperListDialogResultCode {
  HELPER_LIST_DIALOG_CANCEL = 0,
  HELPER_LIST_DIALOG_OK,
  HELPER_LIST_ACTION_FORM_DIALOG_SAVED,
  HELPER_LIST_ALL_PARAMS_SAVED
}

/**
 * Must be a class and not an interface for typescript type guards to work.
 */
export class LMHelperListDialogResult {
  result: LMHelperListDialogResultCode;
  dataView?: LMDataView;
  status?: string;
  helperListAction: LMBusListRefAction;
}

@Injectable()
export class LMHelperListDialogService {
  constructor(
    private lmBusyIndicatorService: LMBusyIndicatorService,
    private lmLoggerService: LMLoggerService,
    private lmUniqueIdService: LMUniqueIdService,
    private lmUrlInfoBuilderService: LMUrlInfoBuilderService,
    private lmModalWrapperService: LMModalWrapperService
  ) {
  }

  public dialog: LMModalDialogWrapperRef<any>;
  private dialogOpened = false;
  private buttons: SohoModalButton[];
  private readonly dialogId = 'HelperList'; 

  public get hasOpenDialog() {
    return this.dialogOpened;
  }

  // LMCLIENT-33598: update helper list button state
  public updateHelperListButtonState(actions: LMActionSpec[], dataViewSet: LMDataViewSet, rows?: any[]) {

    /* !!!IMPORTANT!!!
      This function is temporarily disabled due to applications  
      need time to adapt to this new helper list rule.
      See LMCLIENT-35152  
    */
   return false;

   /*
   const buttonset: SohoButtonsetStatic = this.dialog.buttonsetAPI;
   const buttons: Array<SohoButtonOptions> = buttonset?.settings?.buttons || [];

   if (!dataViewSet?.data?.length || !rows?.length) {
     //disable all helper actions 
     for (let i = 1; i < buttons.length; i++) {  
       buttonset.at(i).disabled = true;
     }
   } else {
     //check valid helper actions for the selected dataviews 
     const validInstanceActions: Array<LMActionSpec> = this.lmActionService.getValidListInstanceActions(actions, dataViewSet, rows);

     validInstanceActions.forEach(value => {
       const id = this.lmUniqueIdService.uniqueId([ this.dialogId, value.name ]);
       for (let i = 1; i < buttons.length; i++) {  
         if (buttons[i].id === id) {
           buttonset.at(i).disabled = false;
         }
       } 
     });
   }
   */
  }

  public runHelperListDialog(listSpec: LMListSpec, fromDataView: LMDataView, contextDataView: LMDataView, helperListActions: Array<LMBusListRefAction>,
    parentListComponent: LMListComponent, placeholder: ViewContainerRef): Observable<LMHelperListDialogResult> {
    return new Observable<LMHelperListDialogResult>(observer => {
      this.lmLoggerService.log([ 'LMHelperListDialog', 'formService.getFormSpec()', 'Complete' ]);

      const helperListDialog$: Subject<LMHelperListDialogResult> = new Subject<LMHelperListDialogResult>();
      const listUrlinfo = this.lmUrlInfoBuilderService.getListUrlInfoFromListSpec(listSpec);

      let dlgComponent: LMHelperListDialogComponent;
      const title = Soho.Locale.translate('Select');

      const attributes: SohoAttributesArray = [ {
        name: 'data-automation-id',
        // value: 'lm-helper-list-modal'
        value: `lm-${listSpec?.busListSpec?.automationId}-modal`
      } ];

      const sohoModalOptions: SohoModalOptions = {
        fullsize: 'responsive',
        attributes
      };

      // Todo: Button text
      this.buttons = [
        // TODO: The button default disables the button. A bug in controls?
        // tslint:disable-next-line - shadowed variable e
        {
          id:    this.lmUniqueIdService.uniqueId([ this.dialogId, LMDialogButtonKey.CLOSE ]),
          text:  Soho.Locale.translate(LMDialogButtonKey.CLOSE),
          cssClass: 'btn-cancel',
          click: (e, modal) => {
            this.dialog.close(<LMHelperListDialogResult>{
              result: LMHelperListDialogResultCode.HELPER_LIST_DIALOG_CANCEL
            });
          }
        }
      ];

      for (let i = 0; i < helperListActions.length; i++) {
        this.buttons.push(
          {
            id:   this.lmUniqueIdService.uniqueId([ this.dialogId, helperListActions[ i ].actionSpec.name ]),
            text: helperListActions[ i ].actionSpec.label,
            click: (e, modal) => {
              helperListDialog$.next(<LMHelperListDialogResult>{
                result:           LMHelperListDialogResultCode.HELPER_LIST_DIALOG_OK,
                helperListAction: helperListActions[ i ]
              });
            }
          }
        );
      }

      helperListDialog$.subscribe((result: LMHelperListDialogResult) => {
        if (result.result === LMHelperListDialogResultCode.HELPER_LIST_ACTION_FORM_DIALOG_SAVED
            || result.result === LMHelperListDialogResultCode.HELPER_LIST_ALL_PARAMS_SAVED) {
          parentListComponent.listContentComponent.refresh().subscribe();
        }
      });

      if (helperListActions.length === 1) {
        this.buttons[ 1 ].isDefault = true;
      }
      this.lmBusyIndicatorService.hideBusyIndicator();

      this.dialog = this.lmModalWrapperService
        .modal(LMHelperListDialogComponent, sohoModalOptions)
        .buttons(this.buttons)
        .title(title)
        .isAlert(false)
        .autoFocus(false)
        .open()
        .apply((helperList: LMHelperListDialogComponent) => {
          dlgComponent = helperList;
          helperList.listUrlInfo = listUrlinfo;
          helperList.listSpec = listSpec;
          helperList.fromDataView = fromDataView;
          helperList.helperListOptions = {
            helperListActions,
            helperListDialog$,
            contextDataView
          };
        //
        // // TODO: Set the title after processing message rules
        // // dialog.title(formSpec.busFormSpec.title);
        // helperList.titleChanged.first().subscribe(newTitle => {
        //   this.dialog.title(newTitle);
        //   helperList.triggerDetectChanges();
        // });
        })
        .afterClose(result => {
          helperListDialog$.complete();
          observer.next(result);
          observer.complete();
          this.dialogOpened = false;
        })
        .afterOpen(() => {
          this.dialogOpened = true;
        });
    });
  }
}
